import { Tooltip } from "antd";
import { MessageDirection } from "../../../pages/MessageUtils";
import { formatTime } from "../../../pages/utils/commonUtils";

const STATUS_ICON_CONFIG = {
  queued: { className: "queue-icon", dataCy: "queue-icon" },
  sent: { className: "success-icon", dataCy: (s) => `success-icon-${s}` },
  failed: { className: "failure-icon", dataCy: "message-send-failure-icon" },
  undelivered: { className: "failure-icon", dataCy: "message-send-failure-icon" },
  delivered: { className: "delivered-icon", dataCy: (s) => `success-icon-${s}` },
  read: { className: "read-icon", dataCy: (s) => `success-icon-${s}` },
};

export default function DateAndStatus({ conversationObject }) {
  const status = conversationObject?.messageStatus || conversationObject?.status;
  const iconConfig = status ? STATUS_ICON_CONFIG[status] : null;
  const dataCy = iconConfig && (typeof iconConfig.dataCy === "function" ? iconConfig.dataCy(status) : iconConfig.dataCy);

  return (
      <div className={`d-flex ${conversationObject?.direction === MessageDirection.OUTBOUND ? "justify-content-end" : ""}`}>
        <span
          className="d-flex align-items-center hs-color-pale-grey hs-fs-9-px"
        >
          {formatTime(conversationObject?.createdTime)}
          {conversationObject?.direction === MessageDirection.OUTBOUND && (
            <span className={`ps-1`}>
              <Tooltip
                title={
                  <span className="text-capitalize">
                    {conversationObject?.errorCode ? (
                      <div>Error Code : {conversationObject?.errorCode}</div>
                    ) : (
                      <div> {status}</div>
                    )}
                    {conversationObject?.errorMessage && <div>{conversationObject?.errorMessage}</div>}
                  </span>
                }
              >
                {iconConfig && (
                  <div className={`actionIconsSprite ${iconConfig.className}`} data-cy={dataCy} />
                )}
              </Tooltip>
            </span>
          )}
        </span>
      </div>
    );
  }